module.exports = __webpack_public_path__ + "img/farewell-of-snezhnaya-2.c29abd18.webp";